import { theme } from 'styles/theme'
import { Box, Button, ButtonProps } from '@mui/joy'
import { RightArrowSvg } from '../../static/image/common/SvgAssets'
import React, { ReactNode } from 'react'

interface ListItemButtonProps extends ButtonProps {
  icon?: ReactNode;
  text?: ReactNode;
  onClick?: () => void;
  endDecorator?: ReactNode;
}

export default function ListButton({
  variant = "Plain",
  size = "md",
  color = "neutral",
  icon,
  text,
  onClick,
  endDecorator = <RightArrowSvg color={theme.vars.palette.Content.SuperWeak} />,
  sx: overrideSx, // props에서 sx를 overrideSx 라는 이름으로 추출
  ...restButtonProps // sx를 제외한 나머지 props
}: ListItemButtonProps) {
  return (
    <Button
      fullWidth
      size={size}
      variant={variant}
      color={color}
      onClick={() => {
        if (onClick) onClick();
        // Removed blur() call to maintain background styling after touch on mobile
      }}
      sx={{
        height: "64px",
        borderRadius: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center", // 세로 중앙 정렬
        minWidth: 0,
        paddingInline: 0,
        px: "20px",
        ...overrideSx,

        // // PC 에서는 Hover, active 없앤다
        // "@media (min-width: 1024px)": {
        //   "&:hover": {
        //     backgroundImage: "none",
        //   },
        // },
        // "&:not(.Mui-disabled):active": {
        //   backgroundImage: isInAppWebview
        //     ? `linear-gradient(${theme.vars.palette.hoverLight}, ${theme.vars.palette.hoverLight})`
        //     : "none",
        // },
      }}
      {...restButtonProps}
    >
      <Box
        sx={{ display: "flex", alignItems: "flex-start", gap: icon ? 1 : 0 }}
      >
        {icon}
        <Box sx={{ display: "block", textAlign: "left" }}>{text}</Box>
      </Box>

      {endDecorator}
    </Button>
  );
}
